<template>
  <main class="container text-center py-5" :dir="currentLanguage === 'ar' ? 'rtl' : 'ltr'">
    <p class="text-muted mb-2">404</p>
    <h1 class="mb-3">
      {{ currentLanguage === 'ar' ? 'الصفحة غير موجودة' : 'Page not found' }}
    </h1>
    <p class="text-muted mb-4">
      {{ currentLanguage === 'ar'
        ? 'تعذر العثور على الصفحة المطلوبة.'
        : 'The page you requested could not be found.' }}
    </p>
    <router-link class="btn btn-primary" :to="{ name: 'home' }">
      {{ currentLanguage === 'ar' ? 'العودة إلى الأدوات' : 'Back to tools' }}
    </router-link>
  </main>
</template>

<script>
export default {
  name: 'NotFound',
  computed: {
    currentLanguage() {
      return this.$store.state.currentLanguage;
    }
  }
}
</script>
